import { LOAD_COUNTRIES, LOAD_OVERVIEW, LOAD_STATISTICS, LOAD_PLAYS, LOAD_DEVICES } from './actions';

const initialState = {
  overview: {
    albums: {},
    comments: {},
    articles: {},
    users: {},
  },

  countries: [],

  // For the plays log in the dashboard
  plays: {
    total: 0,
    log: [],
  },

  stats: {
    plays: [],
    likes: [],
  },

  devices: {
    devices: [],
    platforms: [],
    browsers: [],
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_COUNTRIES.SUCCESS:
      return {
        ...state,
        countries: action.payload.countries.map(item => [item.country, item.total]),
      };
    case LOAD_OVERVIEW.SUCCESS:
      return {
        ...state,
        overview: action.payload.data,
      };
    case LOAD_STATISTICS.SUCCESS:
      return {
        ...state,
        stats: action.payload.data,
      };
    case LOAD_PLAYS.SUCCESS:
      return {
        ...state,
        plays: {
          ...state.plays,
          total: action.payload.meta.total,
          log: action.payload.plays,
        },
      };
    case LOAD_DEVICES.SUCCESS:
      return {
        ...state,
        devices: action.payload
      };
    default:
      return state;
  }
}